import React from 'react'
import Svg from './Svg'
export const SvgComment = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M10.919 2.287C4.87 2.287 0 6.113 0 10.839a7.426 7.426 0 002.269 5.203l-.538 5.097 4.992-2.397a13.48 13.48 0 004.189.657c6.049 0 10.912-3.833 10.912-8.56 0-4.726-4.878-8.552-10.905-8.552zm-3.743 9.929c-.914 0-1.485-.99-1.027-1.782a1.187 1.187 0 111.027 1.782zm3.743 0c-.914 0-1.485-.99-1.027-1.782a1.187 1.187 0 111.027 1.782zm3.736 0a1.188 1.188 0 11.001-2.376 1.188 1.188 0 01-.001 2.376z" />
  </Svg>
))
SvgComment.isIcon = true
export default SvgComment
